<script>
import { listWord } from '@/constants/data'
import LABELS from '@/constants/labels'

export default {
  props: {
    optionsFont: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      config: {
        title: 'テキストを入力してください',
        subTitle: '（全角15文字・半角30文字まで）',
        message: null,
        textSubmitButton: 'テキストを追加',
        customClass: 'add-text',
        linkTo: '',
      },
      addTextForm: {
        fontFamily:
          this.optionsFont.length > 0 ? this.optionsFont[0].value : '',
        text: '',
        color: '',
      },
      errors: {},
    }
  },
  computed: {
    mappingLabels() {
      return LABELS
    },
    isValid() {
      if (this.addTextForm.text) {
        return Object.values(this.errors).every(x => !x)
      }
      return false
    },
  },

  methods: {
    resetForm() {
      this.addTextForm.text = ''
      this.addTextForm.fontFamily = this.optionsFont[0].value
      this.errors = {}
    },

    show(item, index) {
      this.visible = true

      this.config.indexText = index
      if (item) {
        this.addTextForm = { ...item }
      } else {
        this.resetForm()
      }
    },

    hide() {
      this.visible = false
      this.errors = {}
      this.$emit('hide')
    },

    getValueSelect(val) {
      this.addTextForm.fontFamily = val
    },

    onSubmitForm() {
      this.hide()
      this.$emit('submit', this.addTextForm, this.config.indexText)
    },

    checkFullHalfWidthText(strVal) {
      let isFullWidth = true

      for (let i = 0; i < strVal.length; i++) {
        const code = strVal.charCodeAt(i)

        if (
          (code >= 0x0020 && code <= 0x1fff) ||
          (code >= 0xff61 && code <= 0xff9f)
        ) {
          isFullWidth = false

          break
        }
      }

      return isFullWidth
    },

    onTextChange(e) {
      this.$set(this.addTextForm, 'text', e.target.value)
      if (e.target.value.length > 30) {
        this.$set(
          this.errors,
          'text',
          this.mappingLabels.maximumInput15JapaneseCharacters
        )
        return
      }
      this.validateText(e.target.value, this.addTextForm.fontFamily)
    },

    onSelectChange(value) {
      if (this.addTextForm.text) {
        this.validateText(this.addTextForm.text, value)
      }
    },

    checkListRestrict(text) {
      const rgx = new RegExp(listWord.join('|'), 'gi')
      if (rgx.test(text)) {
        this.$set(this.errors, 'text', this.mappingLabels.youJustTypedInNGWord)
        this.addTextForm.text = text.replace(rgx, '')
      }
    },

    validateText(text, selectValue) {
      if (selectValue === 'Cabin Condensed' || selectValue === 'Sacramento') {
        if (/^[A-Za-z0-9 ]+$/.test(text)) {
          this.$set(this.errors, 'text', '')
          this.checkListRestrict(text)
        } else {
          this.$set(
            this.errors,
            'text',
            this.mappingLabels.japaneseCharactersNotAllowed
          )
        }
      } else {
        const valueInput = text.split('')

        const fullWidth = []
        valueInput.map(item => {
          if (this.checkFullHalfWidthText(item)) {
            fullWidth.push(item)
          }
        })

        if (fullWidth.length > 15) {
          this.$set(
            this.errors,
            'text',
            this.mappingLabels.maximumInput15JapaneseCharacters
          )
        } else {
          this.$set(this.errors, 'text', '')
          this.checkListRestrict(text)
        }
      }
    },
  },
}
</script>

<template>
  <s-modal :show="visible">
    <div class="add-text-popup" v-if="visible">
      <p class="btn-close-popup" @click="hide()">
        <x-icon-close />
      </p>
      <form ref="addTextForm" :model="addTextForm">
        <div class="add-text-popup_content">
          <p class="add-text-popup_title" v-html="config.title"></p>
          <p class="add-text-popup_sub-title" v-html="config.subTitle"></p>
          <div class="add-text-popup_font">
            <s-select-custom
              v-model="addTextForm.fontFamily"
              :optionsFont="optionsFont"
              :selected="addTextForm.fontFamily"
              @input="onSelectChange"
            ></s-select-custom>
          </div>
          <div class="input-add">
            <textarea
              ref="inputText"
              :value="addTextForm.text"
              name="addText"
              id="addText"
              type="text"
              class="input-add_text"
              autocomplete="off"
              @input="onTextChange"
            ></textarea>
            <p class="error-message">{{ errors.text }}</p>
          </div>

          <div class="add-text-popup_button-group">
            <button
              class="s-button blue-btn"
              @click.prevent="onSubmitForm()"
              :disabled="!isValid"
              :class="{ 'is-disabled': !isValid }"
            >
              <span class="icon">+</span>
              <label>{{ config.textSubmitButton }}</label>
            </button>
          </div>
        </div>
      </form>
    </div>
  </s-modal>
</template>
<style lang="scss" scoped>
@import './modal-add-text.scss';
</style>
